import { useEffect, useState } from "react";
import { Share2 } from "lucide-react";
import { BotaoVoltar } from "@/shared/components/BotaoVoltar";
import { Button } from "@/shared/components/Button";
import { Modal } from "@/shared/components/Modal";
import { CampoTexto } from "@/modules/visitantes/components/Campos";
import { linkWhatsappCompartilhar } from "@/modules/visitantes/utils/regras";

interface Props {
  aberto: boolean;
  nome: string;
  /** Mensagem já montada com tudo que foi preenchido (ver `textoCompartilharContato`). */
  textoInicial: string;
  onClose: () => void;
}

/**
 * Compartilha o contato do visitante com outro líder pelo WhatsApp. Abre o WhatsApp sem
 * destinatário (quem envia escolhe o líder lá). A mensagem leva tudo que foi preenchido e quem
 * compartilha enxerga, e pode ser editada antes de abrir.
 */
export function ModalCompartilharContato({ aberto, nome, textoInicial, onClose }: Props) {
  const [texto, setTexto] = useState("");

  useEffect(() => {
    if (aberto) setTexto(textoInicial);
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [aberto]);

  function abrir() {
    window.open(linkWhatsappCompartilhar(texto), "_blank", "noopener,noreferrer");
    onClose();
  }

  return (
    <Modal titulo="Compartilhar contato" aberto={aberto} onClose={onClose}>
      <p className="mb-3 text-sm text-muted">
        Envia as informações de {nome} para outro líder; você escolhe quem recebe no WhatsApp. Vão
        todas as informações preenchidas que você pode ver. Revise e apague o que não quiser
        compartilhar.
      </p>
      <CampoTexto
        label="Mensagem (pode editar)"
        name="mensagemCompartilhar"
        rows={10}
        maxLength={1000}
        value={texto}
        onChange={(e) => setTexto(e.target.value)}
      />
      <div className="mt-4 flex justify-end gap-2">
        <BotaoVoltar onClick={onClose} className="min-h-11" />
        <Button
          type="button"
          onClick={abrir}
          disabled={texto.trim() === ""}
          className="inline-flex min-h-11 items-center gap-1.5"
        >
          <Share2 size={16} aria-hidden="true" /> Abrir WhatsApp
        </Button>
      </div>
    </Modal>
  );
}
